import React, { FC } from 'react';
import { BaseDialog } from './base-dialog';
import useLocale from '../../hooks/useLocale';
import SignOutPage from '../../views/sign-out-page/sign-out-page';

export const NoAccountDialog: FC = () => {
  const { formatContent } = useLocale();

  return (
    <>
      <SignOutPage redirect={false} />
      <BaseDialog
        dialogId="no-account"
        dialogLabel={formatContent('devhub.dialog.no-account.label')}
        headerText={formatContent('devhub.dialog.no-account.header')}
        bodyText={formatContent('devhub.dialog.no-account.body')}
        buttonText={formatContent('devhub.dialog.no-account.button')}
      />
    </>
  );
};
